import React from 'react';
import {VideoEditorText} from '../VideoEditorText';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
import {ReactComponent as EditScriptIcon} from '../../../assets/images/sound-file-icon.svg';
import {ReactComponent as MuteAudioIcon} from '../../../assets/images/mute-icon.svg';
import {ReactComponent as RegenerateIcon} from '../../../assets/images/regenerate-icon.svg';
import {ReactComponent as DeleteIcon} from '../../../assets/images/trash-icon.svg';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import styles from './EditChunkOptions.module.css';
import {ReactComponent as Dots} from '../../../assets/images/dots-horizontal.svg';
import ContextMenuProviderStore from '../../../modules/ContextMenuProvider/store/ContextMenuProviderStore';
import {inject} from 'mobx-react';

interface Props {
  chunk: GeneratedVideoChunk;
  onEditChunk: (option: EditChunkOption, chunkId: string) => void;
  contextMenuProviderStore?: ContextMenuProviderStore;
  isTiny: boolean;
}

const EditChunkOptions = inject('contextMenuProviderStore')(
  React.memo(
    ({chunk, onEditChunk, contextMenuProviderStore, isTiny}: Props) => {
      const onEditScriptOption = () => {
        contextMenuProviderStore?.close();
        onEditChunk(EditChunkOption.EditScript, chunk.id);
      };
      const onMuteAudioOption = () => {
        contextMenuProviderStore?.close();
        onEditChunk(EditChunkOption.MuteAudio, chunk.id);
      };
      const onRegenerateOption = () => {
        contextMenuProviderStore?.close();
        onEditChunk(EditChunkOption.Regenerate, chunk.id);
      };
      const onDeleteOption = () => {
        onEditChunk(EditChunkOption.Delete, chunk.id);
      };

      const openOptions = (e: React.MouseEvent) => {
        contextMenuProviderStore?.show(
          <div className={styles.options}>
            <div className={styles.option} onClick={onEditScriptOption}>
              <EditScriptIcon className={styles.editVideoOptionIcon} />
              {VideoEditorText.editVideoOptions_EditScript}
            </div>
            <div className={styles.option} onClick={onMuteAudioOption}>
              <MuteAudioIcon className={styles.editVideoOptionIcon} />
              {VideoEditorText.editVideoOptions_MuteAudio}
            </div>
            <div className={styles.option} onClick={onRegenerateOption}>
              <RegenerateIcon className={styles.editVideoOptionIcon} />
              {VideoEditorText.editVideoOptions_Regenerate}
            </div>
            <div
              className={`${styles.option} ${styles.deleteOption}`}
              onClick={onDeleteOption}>
              <DeleteIcon className={styles.editVideoOptionIcon} />
              {VideoEditorText.editVideoOptions_Delete}
            </div>
          </div>,
          {x: e.clientX, y: e.clientY + 25},
        );
      };

      return (
        <div
          className={`${styles.editChunkOptions} ${
            isTiny ? styles.tinyChunk : ''
          }`}>
          <button className={styles.opener} onClick={openOptions}>
            <Dots />
          </button>
        </div>
      );
    },
  ),
);

export default EditChunkOptions;
